export const modeMixin = {
  props: {
    /**
     * set as `team`, `member`, or `package-builder` to adjust challenge builder flow
     */
    mode: {
      type: String,
      required: false,
      validator(mode) {
        return ["team", "member", "package-builder"].indexOf(mode) !== -1;
      }
    }
  }
};
